<template>
	<v-container
			fluid
			style="height: 100%; overflow-y: auto;"
	>
		<div class="headline">Unternehmen eintragen</div>
		<p>
			Dein Unternehmen ist aus oder um Jena und du möchtest in die Übersicht mit aufgenommen werden, dann trage dein Unternehmen in das nachstehende Formular ein.
		</p>
		<v-divider />
		<v-form
				v-model="formValid"
				class="mt-3"
		>
			<div class="text-uppercase">Daten zum Unternehmen / Produkt</div>
			<v-row>
				<v-col
						cols="12"
						md="6"
						lg="5"
				>
					<v-text-field
							label="Überschrift"
							hint="Eine kurze, prägnante Überschrift repräsentiert dein Portfolio und damit deine Verlinkung zu deinem Unternehmen / Produkt."
							persistent-hint
							:rules="[ rules.required ]"
					/>
				</v-col>
				<v-spacer />
				<v-col
						cols="12"
						md="6"
						lg="5"
				>
					<v-text-field
							label="Unternehmen"
							hint="Wie heißt dein Unternehmen?"
							persistent-hint
							:rules="[ rules.required ]"
					/>
				</v-col>
				<v-spacer />
				<v-col
						cols="12"
						lg="11"
				>
					<v-text-field
							label="Onlineshop / Webseite"
							hint="Welche Webseite soll verlinkt werden? Beispiel: https://www.handelt-gemeinsam.de."
							persistent-hint
					/>
				</v-col>
				<v-spacer />
				<v-col
						cols="12"
						md="6"
						lg="5"
				>
					<v-text-field
							label="E-Mail-Addresse"
							persistent-hint
							:rules="[ rules.required, rules.email ]"
					/>
				</v-col>
				<v-spacer />
				<v-col
						cols="12"
						md="6"
						lg="5"
				>
					<v-text-field
							label="Telefonnummer (optional)"
							persistent-hint
					/>
				</v-col>
				<v-spacer />
				<v-col
						cols="12"
						lg="11"
				>
					<v-textarea
							label="Kurzbeschreibung"
							hint="Wofür steht dein Unternehmen ? Welches Produkt bietest du an? (Max: 120 Zeichen)"
							persistent-hint
							counter
							:rules="[ rules.required ]"
					/>
				</v-col>
				<v-spacer />
				<v-col
						cols="12"
						lg="11"
				>
					<v-file-input
							label="Coverfoto"
							hint="Welches Bild soll als Coverfoto in deinem Portfolio dargestellt werden? (Am besten quadratisch mit einer Mindestlänge / Breite von 512px. Ist aber kein Muss, wir skalieren das schon, sodass es gut aussieht. )"
							persistent-hint
							counter
					/>
				</v-col>
				<v-spacer />
				<v-col
						cols="12"
						md="4"
						lg="3"
				>
					<gh-select-category
							:rules="[ rules.required ]"
					/>
				</v-col>
				<v-spacer />
				<v-col
						cols="12"
						md="4"
						lg="3"
				>
					<gh-select-category
					/>
				</v-col>
				<v-spacer />
				<v-col
						cols="12"
						md="4"
						lg="3"
				>
					<gh-select-category
					/>
				</v-col>
				<v-spacer />
				<v-col
						cols="12"
						lg="11"
				>
					<gh-select-shipping
							multiple
							:rules="[ rules.required ]"
					/>
				</v-col>
				<v-spacer />
			</v-row>
			<div class="text-uppercase">Daten zum Unternehmen / Produkt (optional)</div>
			<v-row>
				<v-col
						cols="12"
						md="6"
						lg="5"
				>
					<v-text-field
							label="Straße"
							persistent-hint
					/>
				</v-col>
				<v-spacer />
				<v-col
						cols="12"
						md="3"
						lg="2"
				>
					<v-text-field
							label="PLZ"
							persistent-hint
					/>
				</v-col>
				<v-spacer />
				<v-col
						cols="12"
						md="3"
						lg="5"
				>
					<v-text-field
							label="Ort"
							persistent-hint
					/>
				</v-col>
				<v-spacer />
			</v-row>
			<div class="text-uppercase">Feedback (optional)</div>
			<v-row>
				<v-col
						cols="12"
						lg="11"
				>
					<v-textarea
							persistent-hint
					/>
				</v-col>
				<v-spacer />
			</v-row>
			<v-checkbox>
				<template #label>
					Ich habe die &nbsp;
					<router-link
						to="/"
						style="display: inline;"
					>Datenschutzbestimmungen</router-link>
					&nbsp; für die Verarbeitung meiner persönlichen Daten gelesen
				</template>
			</v-checkbox>
		</v-form>
		<v-btn
				color="primary"
				:disabled="!formValid"
				block
				large
		>Unternehmen jetzt eintragen</v-btn>
	</v-container>
</template>

<script>
import Vue from 'vue'

import jsonShippings from '@/assets/shippings.json';
import GhSelectCategory from '@/components/input/GhSelectCategory'
import GhSelectShipping from '@/components/input/GhSelectShipping'

export default {
	name: 'FormView',
	components: {
		GhSelectShipping,
		GhSelectCategory
	},
	data(){
		return{
			formData: {
			},
			formValid: false,
			title:"",
			company:"",
			street:"",
			c_city:"",
			plz:"",
			url:"",
			descr:"",
			shipping:jsonShippings,
			selectedCatIds:[],
			selectedShipIds:[],
			name:"",
			lastname:"",
			email:"",
			tel:"",
			nr:"",
			img:"",
			lat:null,
			lng:null,
			IMG_FOLDER:"/upload/",
			dsgvoChecked:false,
			submitted:false,
			error:false,
			emptyField:null,
			country:1,//Thüringen
			city:1,//Jena
			token:"jhsZZb5sb*#GbvxSms33DDfsI3#*Y9s",
			dropzoneOptions: {
				url: '/pro.php',
				/* thumbnailWidth: 150, */
				/* maxThumbnailFilesize:1, */
				maxFilesize: 5,
				maxFiles:1,
				createImageThumbnails:false,
				dictDefaultMessage: "<i class='icon solid fa-image mr-1'></i>Coverfoto für dein Portfolio auswählen",
				resizeWidth:1200,
				resizeQuality:0.9,
				addRemoveLinks:true,
				acceptedFiles:"image/*",
				/* resizeMimeType:"image/jpeg" */
			},
			postUrl:"https://getsimpleform.com/messages?form_api_token=4ae27ecb578345f2b03ee6ee74574860",
			rules: {
				required: val => !!val || 'Bitte füll dieses Feld aus!',
				email: val => val.match(/[^@]+@[.\w\d]+\.\w+/) || 'Bitte gib eine gültige E-Mail-Addresse ein'
			}
		}
	},
	computed:{

		hasEmptyField(){
			return this.emptyField!=null;
		},

		dataAsString(){
			return JSON.stringify(this.dataObject);
		},
		dataObject(){
			return {
				id:this.newUuid(),
				title:this.title.trim(),
				descr:this.descr.trim(),
				url:this.url.trim(),
				name:this.name.trim(),
				lastname:this.lastname.trim(),
				email:this.email,
				tel:this.tel.trim(),
				category:this.filterEmptyData(this.selectedCatIds),
				ship:this.getCorrectShippingData(this.selectedShipIds),
				img:this.img,
				country:this.country,
				city:this.city,
				company:this.company.trim(),
				c_city:this.c_city.trim(),
				plz:this.plz.trim(),
				street:this.street.trim(),
				lat:this.lat,
				lng:this.lng
			}
		},
	},
	methods:{
		onUpdatePosition(latLng){
			if(latLng){
				this.lat=latLng.lat;
				this.lng=latLng.lng;
			}
		},
		hasValidPostData(){
			this.emptyField=null;

			if(this.title.trim()==""){
				this.emptyField="Überschrift";
			}else if(this.company.trim()==""){
				this.emptyField="Unternehmen";
			}else if(this.url.trim()==""){
				this.emptyField="Link zur Webseite";
			}else if(this.descr.trim()==""){
				this.emptyField="Kurzbeschreibung";
			}else if(this.email.trim()==""){
				this.emptyField="E-Mail";
			}else if(this.lat==null || this.lng==null){
				this.emptyField="Ort auf Karte";
			}

			return (this.emptyField==null);
		},

		sendingEvent (file, xhr, formData) {
			if(formData){
				formData.append('token', this.token);
			}
		},
		onUploadSuccess(file){//response
			if(file){
				this.img=this.IMG_FOLDER+file.name;
			}
		},
		onUploadError(file, message){//xhr
			console.log(message);
		},
		onSubmitted(e){
			if(this.hasValidPostData()){
				const formData = new FormData(e.target);
				//var formData = new FormData(document.querySelector('form'))
				this.error=false;
				this.submitted=true; //TINY FIX
				try {
					fetch(this.postUrl, { method: 'POST', body: formData })
					.then((response) =>{
						// debugger // eslint-disable-line
						if (response.status >= 400) {
							this.error=true;
							throw new Error("Bad response from server");
						}
						return response.json();
					})
					.then(function(data) {
						this.submitted=true;
						console.log(data);
					});
				} catch (error) {
					this.error=true;
				}
			}

			//document.getElementById("form_new_entry").submit();
			return false;
		},
		showDatenschutzModal() {
			this.$refs.datenschutzModal.show();
		},
		getShipmentById(id){
			return this._.find(this.shipping, ['id', (id+1)]); // need +1 here to match Shippment json data
		},
		getCorrectShippingData(data){
			let res=[];
			if(this._.isArray(data)){
				data.forEach((e,k) => {
					if(e){
						let ship=this.getShipmentById(k);
						if(ship){
							res.push(ship.id);
						}
					}
				});
				return res;
			}
		}
	},
	beforeRouteEnter: (to,from,next) => {
		next(() => {
		setTimeout(()=>{
				window.scrollTo(0, 0);
			},300);
		});
	},
	mounted(){
		Vue.set(this.selectedCatIds,0,"0");
		Vue.set(this.selectedCatIds,1,"0");
		Vue.set(this.selectedCatIds,2,"0");
	}
}
</script>


<style>
.dz-message{
	font-family: "Source Sans Pro", Helvetica, sans-serif!important;
}
</style>

<style scoped>
	.form-descr{
		font-style: italic;
	}
	.form-error{
		color:red;
		text-align: center;
		font-size: large;
	}
</style>
